import { motion, useReducedMotion } from "framer-motion";
import { BellRing, Timer, MessageSquareReply, RefreshCw, TrendingUp } from "lucide-react";

const cards = [
  { icon: BellRing, label: "New Lead Received", value: "Inbound · Web Form", tone: "neutral", dot: true },
  { icon: Timer, label: "Response Time", value: "04m 12s", tone: "gold" },
  { icon: MessageSquareReply, label: "Quote Follow-Up", value: "Active Sequence", tone: "neutral", badge: "Active" },
  { icon: RefreshCw, label: "Past Customer Opportunity", value: "Reactivation Ready", tone: "neutral", badge: "Ready" },
  { icon: TrendingUp, label: "Revenue Opportunity", value: "High Priority", tone: "gold-solid" },
];

function ActivityCard({ icon: Icon, label, value, tone, badge, dot, i, reduce }) {
  const goldSolid = tone === "gold-solid";
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 }}
      className={`relative w-full rounded-2xl px-4 py-3.5 ${
        goldSolid ? "bg-gradient-to-br from-brand-gold to-brand-gold-deep text-white shadow-luxe-gold" : "glass-panel shadow-luxe"
      }`}
    >
      <motion.div
        animate={reduce ? {} : { y: [0, -6, 0] }}
        transition={{ duration: 5 + i, repeat: Infinity, ease: "easeInOut", delay: i * 0.4 }}
        className="flex items-center gap-3"
      >
        <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ${goldSolid ? "bg-white/20" : "bg-brand-gold/12"}`}>
          <Icon className={`h-4.5 w-4.5 ${goldSolid ? "text-white" : "text-brand-gold"}`} strokeWidth={1.6} />
        </span>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <p className={`font-sans text-[10px] uppercase tracking-[0.14em] truncate ${goldSolid ? "text-white/80" : "text-brand-black/55"}`}>{label}</p>
            {dot && <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse" />}
          </div>
          <p className={`mt-0.5 font-sans text-[13px] font-semibold tracking-tight ${tone === "gold" ? "gold-text" : goldSolid ? "text-white" : "text-brand-black"}`}>{value}</p>
        </div>
        {badge && (
          <span className="shrink-0 rounded-full bg-brand-gold/12 px-2 py-0.5 font-sans text-[9px] font-semibold uppercase tracking-wider text-brand-gold-deep">{badge}</span>
        )}
      </motion.div>
    </motion.div>
  );
}

export default function ActivityCards({ className = "flex flex-col gap-3" }) {
  const reduce = useReducedMotion();
  return (
    <div className={className} data-testid="portal-activity-cards">
      {cards.map((c, i) => (
        <ActivityCard key={c.label} {...c} i={i} reduce={reduce} />
      ))}
    </div>
  );
}
